export const getHeaderHeight = (): number => {
    const header = document.querySelector(".second-head") as HTMLElement;
    return header ? header.offsetHeight : 0;
};

export const smoothScrollToElement = (selector: string, offset: number = 10): void => {
    const element = document.querySelector(selector) as HTMLElement;
    if (!element) return;

    const headerHeight = getHeaderHeight();
    const targetPosition = element.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
        top: targetPosition - headerHeight - offset,
        behavior: "smooth"
    });
};
